const bcrypt = require('react-native-bcrypt');
import {salt} from '../constants/hash';

export const hashPassword = (password: string): string => bcrypt.hashSync(password, salt);
